import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import EmailOptInForm from '@business/contact/EmailOptInForm';


export class EmailOptInFormTranslationGeneratedEntityManager<B extends EmailOptInFormTranslationGenerated> extends EntityTranslationManager<B>
{

    constructor(parameters: EntityManagerParameters<B>)
    {
        super({
            name: parameters.name ?? 'EmailOptInFormTranslation',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'emailOptInForm', type: BusinessEntityFieldType.ForeignKey, isRequiredInput: true, inputName: 'emailOptInFormId', inputProperty: 'emailOptInForm.id', relatedManager: EmailOptInForm.manager },
				{ name: 'language', type: BusinessEntityFieldType.VarChar, isInput: false },
				{ name: 'headline', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'subheadline', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'content', type: BusinessEntityFieldType.Text, isRequiredInput: true },
				{ name: 'confirmationEmailSubject', type: BusinessEntityFieldType.VarChar },
				{ name: 'confirmationEmailBodyIntro', type: BusinessEntityFieldType.Text, isRequiredInput: true },
				{ name: 'confirmationEmailBodyOutro', type: BusinessEntityFieldType.Text, isRequiredInput: true },
				{ name: 'confirmationEmailButtonText', type: BusinessEntityFieldType.VarChar },
				{ name: 'formEmailLabel', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'formNameLabel', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'formPhoneLabel', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'formSubmitButtonText', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'formSuccessMessage', type: BusinessEntityFieldType.Text },
				{ name: 'formConfirmationEmailSentMessage', type: BusinessEntityFieldType.Text },
				{ name: 'formConfirmationSuccessMessage', type: BusinessEntityFieldType.Text },
				{ name: 'redirectUrl', type: BusinessEntityFieldType.VarChar },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'emailOptInFormTranslations',
        });
    }

}
export class EmailOptInFormTranslationGenerated extends BusinessEntityTranslation
{
	/** The name of the foreign key to the translated entity. */
	translatedEntityForeignKeyName: string = 'emailOptInForm';
	/** Reference to the main email opt-in form */
	emailOptInForm!: EmailOptInForm;
	/** Language code (ro, hu, en, de) */
	language!: string;
	/** Main headline text displayed on the form */
	headline: string = '';
	/** Secondary headline text displayed below the main headline */
	subheadline: string = '';
	/** Rich HTML formatted text content for the form (uses rich text editor) */
	content: string = '';
	/** Subject line for the confirmation email */
	confirmationEmailSubject: string = '';
	/** Text displayed before the confirmation button in the email */
	confirmationEmailBodyIntro: string = '';
	/** Text displayed after the confirmation button in the email */
	confirmationEmailBodyOutro: string = '';
	/** Text for the confirmation button in the email */
	confirmationEmailButtonText: string = '';
	/** Label for the email field in the form */
	formEmailLabel: string = '';
	/** Label for the name field in the form (if enabled) */
	formNameLabel: string = '';
	/** Label for the phone field in the form (if enabled) */
	formPhoneLabel: string = '';
	/** Text for the submit button in the form */
	formSubmitButtonText: string = '';
	/** Message to display after successful submission of the form */
	formSuccessMessage: string = '';
	/** Message to display after sending the confirmation email in case of requiring double opt-in confirmation */
	formConfirmationEmailSentMessage: string = '';
	/** Message to display after successful confirmation of the email address */
	formConfirmationSuccessMessage: string = '';
	/** URL to redirect after successful submission or confirmation */
	redirectUrl: string = '';

}

export default EmailOptInFormTranslationGenerated;